import { Trans, useTranslation } from 'react-i18next';
import clsx from 'clsx';
import { observer } from 'mobx-react-lite';
import { AmountToPay } from 'account/amount-to-pay/amount-to-pay';
import { AmountToPayLayout } from 'account/amount-to-pay/amount-to-pay.store';
import { Button } from 'components/buttons/button';
import { ButtonSize, ButtonType } from 'components/buttons/button-types';
import { FeatureFlag } from 'core/enums/feature-flag';
import { Util } from 'utils/common.utils';
import { PopupStore } from '../popup.store';
import styles from '../popup.module.scss';

export const ReconnectUpsizePopup = observer<{ onReconnect: (() => void) | undefined }>(({ onReconnect }) => {
  const { t } = useTranslation();

  const handleReconnect = () => {
    if (onReconnect) {
      onReconnect();
    }

    return;
  };

  return (
    <div className={clsx(styles.genericPopup, 'align-items-center text-center')}>
      <div className={styles.upsizeText}>
        <Trans
          i18nKey={'upsizePopup.text'}
          components={{ b: <b></b>, img: <img src={Util.GetImageAsset('upsize-text/upsized.png')} /> }}
        />
      </div>
      <img src={Util.GetImageAsset('upsize-text/upsize-main.png')} alt="Main image" />
      <Button
        analyticsComponentName="reconnectUpsizeButton"
        meta={{
          name: 'Reconnect',
          type: ButtonType.OutlineDark,
          title: t('buttons.reconnect'),
          areaName: 'get reconnected to upsize',
        }}
        onClick={handleReconnect}
      ></Button>
    </div>
  );
});